import { ContactInformationFormType } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';

export const ContactInformationMap = {
  fromFormToDto: (formValues: ContactInformationFormType) => {
    return {
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      email: formValues.email,
      ...(formValues.dialCode && formValues.phoneNumber
        ? { phoneNumber: `+${formValues.dialCode.dialCode}${formValues.phoneNumber}` }
        : {}),
      documentNumber: formValues.documentNumber,
    };
  },
};
